import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = sessionStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-900 text-white px-6 py-4 shadow-lg z-50 animate-fadeIn">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm flex-1">
          We use cookies to improve your shopping experience and secure payment
          processing. By using Exudee Hampers, you agree to our{" "}
          <a
            href="/privacy-policy"
            className="underline text-blue-300 hover:text-blue-400 transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{" "}
          and{" "}
          <a
            href="/cookie-policy"
            className="underline text-blue-300 hover:text-blue-400 transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>.
        </p>

        <button
          onClick={handleAccept}
          className="flex-shrink-0 bg-blue-600 rounded-lg hover:bg-blue-700 transition text-white px-5 py-2 text-sm font-medium"
        >
          Accept All
        </button>
      </div>
    </div>
  );
}
